
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ExchangeRateGrid extends Serenity.EntityGrid<ExchangeRateRow, any> {
        protected getColumnsKey() { return 'OMS.ExchangeRate'; }
        protected getDialogType() { return ExchangeRateDialog; }
        protected getIdProperty() { return ExchangeRateRow.idProperty; }
        protected getInsertPermission() { return ExchangeRateRow.insertPermission; }
        protected getLocalTextPrefix() { return ExchangeRateRow.localTextPrefix; }
        protected getService() { return ExchangeRateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}